module.exports = __webpack_public_path__ + "static/media/Smilies-Black-2022.0c909123.svg";